let listenerNo = 0;
class ScrollListener {
    constructor() {
        this.init = () => {
            window.addEventListener('scroll', this.raiseCallBack);
        };
        this.setListener = (callback) => {
            listenerNo += 1;
            this.listener.push({
                callback,
                listenerNo,
            });
            return listenerNo;
        };
        this.call = () => {
            this.raiseCallBack();
        };
        this.deleteListener = (findNo) => {
            this.listener = this.listener.filter((findObj) => findNo !== findObj.listenerNo);
        };
        this.raiseCallBack = () => {
            const { scrollTop } = document.documentElement;
            const giveScrollTop = Number.isNaN(scrollTop) ? 0 : scrollTop;
            this.listener.forEach(({ callback }) => {
                callback(giveScrollTop);
            });
        };
        this.listener = [];
    }
}
export default new ScrollListener();
